import React, { useRef, useEffect, useState } from "react";
import "./ThirdSection.css";

const ThirdSection = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const currentSection = sectionRef.current;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.3 }
    );

    if (currentSection) observer.observe(currentSection);

    return () => {
      if (currentSection) observer.unobserve(currentSection);
    };
  }, []);

  return (
    <div
      className={`third-section-container ${isVisible ? "visible" : ""}`}
      ref={sectionRef}
    >
      <div className="third-box">
        {/* ✅ Top Icon */}
        <div className="third-icon-wrapper">
          <img
            src="/assets/Admin.Diagrams.png"
            alt="Helmet Icon"
            className="third-icon-img"
          />
        </div>

        {/* ✅ Heading */}
        <h2 className="third-title">
          HEXAGON PPM SMART 3D /AVEVA EVERYTHING3D Admin. Isodraft
        </h2>

        {/* ✅ Content Section */}
        <div className="third-list-section">
          <ul>
            <li>Configuring the backing sheet in Draw and then in Isodraft</li>
            <li>
              Managing alternative texts, standard frame texts and attribute
              frame texts
            </li>
            <li>Administrating the nomenclature</li>
            <li>
              Administrating isometric graphic elements (dimensions, tag, etc.)
            </li>
            <li>Creating symbol</li>
          </ul>
        </div>

        {/* ✅ Bottom Images (inside sharp-edged container) */}
        <div className="third-bottom-images">
          <div className="third-image-wrapper">
            <img
              src="/assets/third-Section-image-1.png"
              alt="CAD screenshot 1"
              className={`third-bottom-img left ${
                isVisible ? "visible" : ""
              }`}
            />
            
          </div>

          <div className="third-image-wrapper">
            <img
              src="/assets/third-Section-image-2.png"
              alt="CAD screenshot 2"
              className={`third-bottom-img right ${
                isVisible ? "visible" : ""
              }`}
            />
            <p>Creation of Isometrics</p>
            
            
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThirdSection;
